import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core'
import {CarouselComponent} from 'ngx-owl-carousel-o'
import {OptionsNgxOwCarouselService} from 'dmmp-services'

@Component({
  selector: 'dmmp-featured-events',
  templateUrl: './featured-events.component.html'
})
export class FeaturedEventsComponent implements OnInit {

  @Input() module
  @Input() data
  @Input() identifier
  @Output() redirectPage = new EventEmitter()
  @ViewChild('owl') carousel: CarouselComponent
  configCarousel
  currentPage = 1
  totalPages

  constructor(private options: OptionsNgxOwCarouselService, private cdRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.totalPages = this.data?.content?.length
    this.configCarousel = this.options.configurationBenefits(this.module)
  }

  newPageEvent(newPage) {
    if (newPage?.direction === 'next') {
      this.carousel.next()
      this.currentPage = newPage?.number
    } else {
      this.carousel.prev()
      this.currentPage = newPage?.number
    }
  }

  nextPage() {
    if (this.module?.loop && (this.totalPages < this.currentPage + 1)) {
      this.newPageEvent({number: 1, direction: 'next'})
    } else {
      this.newPageEvent({number: this.currentPage + 1, direction: 'next'})
    }
  }

  previousPage() {
    if (this.module?.loop && (this.currentPage - 1) === 0) {
      this.newPageEvent({number: this.totalPages, direction: 'prev'})
    } else {
      this.newPageEvent({number: this.currentPage - 1, direction: 'prev'})
    }
  }

  changeOwl(event) {
    if (event?.startPosition + 1 !== this.currentPage) {
      this.currentPage = event?.startPosition + 1
    }
  }
}
